{
  "name": "@ns/onboard-company-delegate",
  "version": "1.0.0",
  "description": "Create a invitation to onboard a delegate to take some actions on behalf of the company's director.",
  "inputs": {},
  "outcomes": {
    "skip": {},
    "invite": {}
  },
  "jobMetadata": [
    "INVITE_DELEGATE"
  ],
  "workflowMetadata": [
    "INVITATION_ID"
  ]
}
